import { toast } from 'react-toastify';
import StyledHeadingText from '../../components/Fonts/StyledHeadingText';
import { patchOrderPayment } from '../../services/orders';
import Dropdown from '../../components/inputFields/DropDown';
import Button from '../../components/buttons/Button';
import { useState } from 'react';
import ShowModal from '../../utils/ShowModal';
import OrderPaymentsAddPopView from './OrderPaymentsAddPopView';
import { getUserRole } from '../../helpers/local_storage_helpers';
import GalleryComponent from '../../components/GalleryComponent';
import { BiEdit, BiSave, BiX } from 'react-icons/bi';

function OrderPaymentsPopView({ item, onOperation }) {
    const [modalIsPaymentOpen, setIsPaymentOpen] = useState(false);
    const [openingItem, setOpeningItem] = useState({});
    
    // Track which payment is being edited
    const [editingPaymentId, setEditingPaymentId] = useState(null);
    // Track the temporary edits
    const [editData, setEditData] = useState({});

    const handleEditClick = (payment) => {
        setEditingPaymentId(payment.payment_id || payment.id);
        setEditData({
            payment_mode: payment.payment_mode,
            payment_date: payment.payment_date ? payment.payment_date.split('T')[0] : "",
            payment_amount: payment.payment_amount,
            payment_status: payment.payment_status
        });
    };

    const handleCancelEdit = () => {
        setEditingPaymentId(null);
        setEditData({});
    };

    const handleSaveEdit = async (payment) => {
        try {
            let res = await patchOrderPayment({
                data: editData,
                id: payment.payment_id || payment.id,
            });
            if (res.status === 200) {
                toast.success(`Payment Updated`);
                setEditingPaymentId(null);
                setEditData({});
                onOperation();
            } else {
                toast.error(`Unable to Update Payment`);
            }
        } catch (error) {
            console.error("Error in Payments:", error);
            toast.error("Error updating payment");
        }
    };

    const handleRowUpdate = async (item, field, value) => {
        try {
            const data = {
                [field]: value,
            };
            let res = await patchOrderPayment({
                data: data,
                id: item.payment_id || item.id, // Fallback to id if payment_id is missing
            });
            if (res.status === 200) {
                toast.success(`${field.replace("payment_", "")} Updated`);
                onOperation();
            } else {
                toast.error(`Unable to Update ${field.replace("payment_", "")}`);
            }
        } catch (error) {
            console.error("Error in Payments:", error);
            toast.error("Error updating payment");
        }
    };

    const openPaymentModal = () => {
        setOpeningItem(item);
        setIsPaymentOpen(true);
    };

    // Close modal
    const closePaymentModal = () => {
        setIsPaymentOpen(false);
        setOpeningItem({});
    };

    const onPaymentSave = async () => {
        closePaymentModal();
        onOperation();
    };

    return (
        <div className="w-full flex-1">
            <div className="flex flex-row justify-between mt-2 items-center">
                <div className="flex flex-row gap-2">
                    <StyledHeadingText text="Order Payments" TextColor={"text-gray-500 font-normal"} />
                    <p className={`${item?.remaining_payment > 0 ? "text-red-600 font-bold" : "hidden"}`}>(Due Payment: ₹{item?.remaining_payment})</p>
                </div>
                {
                    onOperation && getUserRole() !== 'staff' && (
                        <Button
                            type="submit"
                            className="text-white bg-primary hover:bg-primary-dark font-sm rounded-lg text-sm w-full px-8 py-1.5 text-center max-w-40"
                            onClick={() => openPaymentModal()}
                        >
                            Add Payment
                        </Button>
                    )
                }
            </div>
            {item.payments && item.payments.length !== 0 ? (
                <div className="flex flex-col overflow-y-auto gap-2 mt-2 max-h-full">
                    {item?.payments?.map((paymentItem, index) => (
                        <div key={index} className='p-4 rounded-lg border'>
                            <div className="flex flex-row gap-3">
                                <div className='flex flex-col gap-2 flex-1'>
                                    <div className="flex justify-between items-start">
                                        <h3 className='font-medium text-gray-800 flex items-center gap-2'>
                                            {/* Mode is editable, Method is read-only */}
                                            {paymentItem.payment_method !== "N/A" && `Method: ${paymentItem.payment_method}`}
                                            {" Mode: "}
                                            {editingPaymentId === (paymentItem.payment_id || paymentItem.id) ? (
                                                <select
                                                    className="border rounded px-2 py-1 text-sm bg-white"
                                                    value={editData.payment_mode}
                                                    onChange={(e) => setEditData({...editData, payment_mode: e.target.value})}
                                                >
                                                    <option value="UPI">UPI</option>
                                                    <option value="CARD">CARD</option>
                                                    <option value="CASH">CASH</option>
                                                    <option value="CHEQUE">CHEQUE</option>
                                                    <option value="BANK_TRANSFER">BANK_TRANSFER</option>
                                                    <option value="Razorpay">RAZORPAY</option>
                                                    <option value="SBI_UPI">SBI_UPI</option>
                                                    <option value="SARAL_UPI">SARAL_UPI</option>
                                                </select>
                                            ) : paymentItem.payment_mode}
                                            <span> (on </span>
                                            {editingPaymentId === (paymentItem.payment_id || paymentItem.id) ? (
                                                <input
                                                    type="date"
                                                    className="border rounded px-2 py-1 text-sm bg-white"
                                                    value={editData.payment_date}
                                                    onChange={(e) => setEditData({...editData, payment_date: e.target.value})}
                                                />
                                            ) : paymentItem.payment_date}
                                            <span>)</span>
                                        </h3>
                                        
                                        {onOperation && getUserRole() === "admin" && (
                                            <div className="flex gap-2">
                                                {editingPaymentId === (paymentItem.payment_id || paymentItem.id) ? (
                                                    <>
                                                        <button 
                                                            className="text-white bg-green-500 hover:bg-green-600 rounded px-2 py-1 flex items-center text-xs"
                                                            onClick={() => handleSaveEdit(paymentItem)}
                                                        >
                                                            <BiSave className="mr-1"/> Save
                                                        </button>
                                                        <button 
                                                            className="text-white bg-red-500 hover:bg-red-600 rounded px-2 py-1 flex items-center text-xs"
                                                            onClick={handleCancelEdit}
                                                        >
                                                            <BiX className="mr-1"/> Cancel
                                                        </button>
                                                    </>
                                                ) : (
                                                    <button 
                                                        className="text-white bg-blue-500 hover:bg-blue-600 rounded px-3 py-1 flex items-center text-xs"
                                                        onClick={() => handleEditClick(paymentItem)}
                                                    >
                                                        <BiEdit className="mr-1" /> Edit
                                                    </button>
                                                )}
                                            </div>
                                        )}
                                    </div>

                                    {/* Details Grid */}
                                    <div className='grid grid-cols-4 gap-4 mt-2 text-sm'>
                                        <div className='flex flex-col items-start'>
                                            <span className='text-gray-500'>Amount</span>
                                            {editingPaymentId === (paymentItem.payment_id || paymentItem.id) ? (
                                                <input
                                                    type="number"
                                                    className={`border rounded px-2 py-1 text-sm bg-white font-medium ${editData.payment_status === "PENDING" ? "text-red-600" : "text-green-600"} w-24`}
                                                    value={editData.payment_amount}
                                                    onChange={(e) => setEditData({...editData, payment_amount: e.target.value})}
                                                />
                                            ) : (
                                                <span className={`font-medium py-1 ${paymentItem.payment_status === "PENDING" ? "text-red-600" : "text-green-600"}`}>₹{paymentItem.payment_amount}</span>
                                            )}
                                        </div>
                                        {
                                            paymentItem.payment_method !== "N/A" && (
                                                <div className='flex flex-col items-start'>
                                                    <span className='text-gray-500'>Method</span>
                                                    <span className='font-medium py-1'>{paymentItem.payment_method}</span>
                                                </div>
                                            )
                                        }
                                        <div className='flex flex-col items-start'>
                                            <span className='text-gray-500'>Mode</span>
                                            <span className='font-medium py-1'>{paymentItem.payment_mode}</span>
                                        </div>
                                        <div className='flex flex-col items-start'>
                                            <span className='text-gray-500'>Payment Status</span>
                                            <span className='font-medium'>
                                                {editingPaymentId === (paymentItem.payment_id || paymentItem.id) ? (
                                                    <select
                                                        className="border rounded px-2 py-1 text-sm bg-white"
                                                        value={editData.payment_status}
                                                        onChange={(e) => setEditData({...editData, payment_status: e.target.value})}
                                                    >
                                                        <option value="PENDING">PENDING</option>
                                                        <option value="COMPLETED">COMPLETED</option>
                                                        <option value="FAILED">FAILED</option>
                                                    </select>
                                                ) : (
                                                    <div className={`flex flex-col py-1`}>
                                                        <span className={`font-medium ${paymentItem.payment_status === "PENDING" ? "text-red-600" : "text-green-600"} `}>
                                                            {paymentItem.payment_status}
                                                        </span>
                                                    </div>
                                                )}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                {
                                    paymentItem.image && (
                                        <div className='max-w-24 object-fit rounded-md border items-center'>
                                            <GalleryComponent openingComponent={<img src={paymentItem.image} className='max-w-24 object-fit rounded-md border' />} activeIndex={index} images={item.payments ?? []} />
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    ))}
                </div>
            ) : null}
            <ShowModal contentLabel={"Payment Add alert"} isOpen={modalIsPaymentOpen} modalWidth="50%" onRequestClose={closePaymentModal} componentToPass={<OrderPaymentsAddPopView item={openingItem} onOperation={() => onPaymentSave()} />} />
        </div >);
}

export default OrderPaymentsPopView;